export default {
  namespaced: true,
  scripts: {
    title: "scripts",
    title_main: "scripts",
    action_add: 'Create script',
    action_update: 'Update script',
    base_commands: 'Base scripts',
    custom_commands: 'Custom scripts',
    fields: {
      name: {
        label: 'Script name',
        placeholder: 'Script name'
      },
      description: {
        label: 'Script description',
        placeholder: 'Script description'
      },
      requirements: {
        label: 'Requirements (optional)'
      }
    },
    messages: {
      success_created: 'Script successfully created',
      success_updated: 'Script successfully updated',
      layout_empty: 'Cannot save an empty script',
      connections_empty: 'Connectionless nodes are not allowed',
      connections_qty_exceeded: 'Nodes with multiple connections are not allowed',
      incomplete_node_config: 'Incomplete configuration on the following nodes',
    },
  },
};
